import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  Action,
  MutationUpdateSubscriptionPlanArgs,
} from '@tribeplatform/gql-client/types'

import { useQueryClient } from '../../index.js'
import {
  useMutation,
  type UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getSubscriptionInformationKey } from '../../utils/keys/billing.js'
import { getNetworkKey } from '../../utils/keys/network.key.js'

export const useUpdateSubscriptionPlan = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationUpdateSubscriptionPlanArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const queryClient = useQueryClient()
  const { client } = useTribeClient()

  return useMutation<Action, ClientError, MutationUpdateSubscriptionPlanArgs>(
    input =>
      client.mutation({
        name: 'updateSubscriptionPlan',
        args: {
          fields: 'basic',
          variables: input,
        },
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries(getSubscriptionInformationKey())
        queryClient.invalidateQueries(getNetworkKey())
      },
      ...useMutationOptions,
    },
  )
}
